module.exports = __webpack_public_path__ + "static/media/spartacus_icon_light.5e56cab8.svg";